export default __webpack_public_path__ + "static/media/283.c740414f.jpg";